import React, { Component, PropTypes } from 'react';

import EnhancedTextarea from 'material-ui/TextField/EnhancedTextarea';

import { statusConfirmList } from '../../helper';

import Status from '../../../../components/utils/Status';

import { NitroPlaceholder, NitroModal } from 'nitro-components';

import styled from 'styled-components';

const PopupContainer = styled.div`
  padding: 30px 0;
`;

const iconList = [
  {
    icon: 'success',
    variant: 'success',
    value: 2
  },
  {
    icon: 'progress',
    variant: 'base-3',
    value: 4
  },
  {
    icon: 'declined',
    variant: 'failure',
    value: 3
  },
  {
    icon: 'error',
    value: 999
  }
];

//TODO -SRIRAM - NOT HAPPY WITH THE WAY MATERIAL UI TEXT AREA IS BEING USED .. NEED TO LOOK INTO CREATING NITRO COMPONENT FOR TEXT AREA
const approveDeclineTextAreaStyles = {
  width: '100%',
  minWidth: '330px',
  resize: 'none',
  overflow: 'hidden',
  font: 'inherit',
  marginBottom: '10px',
  borderColor: '#e6e6e6',
  borderRadius: '4px',
  fontSize: '14px',
  outline: 'none',
  padding: '13px',
  color: '$color-base-3'
};

const rowsTextArea = 9;

const statusList = statusConfirmList;

class QuoteApprovalActionConfirm extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      reason: ''
    };
  }

  setReason = event => {
    const reason = event.target.value;
    this.setState({
      reason
    });
  };

  handleConfirm = () => {
    this.props.onConfirm(this.state.reason);
  };

  render() {
    const { onCancel, isOpen, action } = this.props;

    const status = statusList.find(status => status.value === action) || {};
    const formattedStatus = iconList.find(s => s.value === status.value);

    return (
      <NitroModal
        isOpen={isOpen}
        close={onCancel}
        action={this.handleConfirm}
        actionLabel="Confirm"
        cancelAction={onCancel}
        cancelLabel="Cancel"
        actionMaxWidth={350}>
        {statusList.find(status => status.value === action) &&
          <PopupContainer>

            <Status iconSize="48" label={status.label} labelSize="2" {...formattedStatus} />

            <NitroPlaceholder size="30" />

            <EnhancedTextarea
              rows={rowsTextArea}
              textareaStyle={approveDeclineTextAreaStyles}
              placeholder={statusList.find(status => status.value === action).placeHolder}
              value={this.state.reason}
              onChange={this.setReason}
            />

          </PopupContainer>}
      </NitroModal>
    );
  }
}

QuoteApprovalActionConfirm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  action: PropTypes.number.isRequired
};

export default QuoteApprovalActionConfirm;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/components/QuoteApprovalActionConfirm.js